// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { FormValidator } from '../../../utils/form';
import classNames from 'classnames/bind';

import formStyle from '../../../assets/styles/form.scss';
import inputStyle from '../../../assets/styles/input.scss';
import style from './Top.scss';

type Props = {
  +isPosting?: boolean;
  +handleChange: (e: SyntheticInputEvent<HTMLInputElement>) => void;
  +handleFocus: (e: Event) => void;
  +name: {
    value: string;
    errors?: string[];
  };
  +readOnly: boolean;
};

const messages = defineMessages({
  name: {
    label: {
      id: 'address.fullName.courier.label',
    },
    placeholder: {
      id: 'address.name.placeholder',
    },
  },
});

export default class Top extends Component<Props> {
  render() {
    const { isPosting, handleChange, handleFocus, name, readOnly } = this.props;
    const nameError = name.errors && FormValidator.buildErrorLabel(name.errors, {
      required: 'address.name.error.required',
    });
    return (
      <form className={formStyle.formWrap}>
        <section className={classNames(formStyle.row, formStyle.inputRow)}>
          <article className={classNames(formStyle.col)}>
            <FormattedMessage id={messages.name.label.id}>{
              txt => (<label className={classNames(formStyle.label,
                { [formStyle.readOnly]: readOnly })}>{txt}:</label>)
            }</FormattedMessage>
            {!readOnly && <input disabled={isPosting}
                                 className={classNames(inputStyle.input, {
                                   [inputStyle.red]: name.errors && name.errors.length,
                                   [inputStyle.lightBlue]: !!name.value,
                                 })}
                                 value={name.value}
                                 onChange={handleChange}
                                 onFocus={handleFocus}
                                 name="name"
                                 placeholder={this.context.intl.formatMessage(messages.name.placeholder)}/>}
            {nameError}
            {readOnly && name.value ?
              <p className={formStyle.text}>{name.value}</p> :
              <FormattedMessage id="address.firstName.label">{
                txt => <p className={formStyle.text}>{txt} - Qempo</p>
              }</FormattedMessage>}
            {readOnly && !name.value && <FormattedMessage id="address.name.courier.hint">{
              txt => <p className={style.hint}>{txt}</p>
            }</FormattedMessage>}
          </article>
        </section>
      </form>
    )
  }
}

Top.propTypes = {
  isPosting: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired,
  name: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

Top.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/elements/AddressForm/CourierType/Top.jsx